import React, { useState } from 'react';
import { FaEnvelope, FaTelegramPlane } from 'react-icons/fa'; // Импорт иконок
import '../css/SubmitComplaintPage.css'; // Импорт стилей

const SubmitComplaintPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [files, setFiles] = useState([]);
  const [photos, setPhotos] = useState([]);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles([...files, ...selectedFiles]);
  };

  const handlePhotoChange = (e) => {
    const selectedPhotos = Array.from(e.target.files);
    setPhotos([...photos, ...selectedPhotos]);
  };

  const handleRemoveFile = (index, type) => {
    if (type === 'file') {
      const updatedFiles = files.filter((_, i) => i !== index);
      setFiles(updatedFiles);
    } else if (type === 'photo') {
      const updatedPhotos = photos.filter((_, i) => i !== index);
      setPhotos(updatedPhotos);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('name', name);
    formData.append('email', email);
    formData.append('message', message);

    files.forEach((file, index) => {
      formData.append(`file_${index}`, file);
    });

    photos.forEach((photo, index) => {
      formData.append(`photo_${index}`, photo);
    });

    try {
      const response = await fetch('https://kaustbreakinglaw.com/submit-complaint', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        alert('Form submitted!');
        // Clear the form after successful submission
        setName('');
        setEmail('');
        setMessage('');
        setFiles([]);
        setPhotos([]);
      } else {
        alert('Error submitting the form.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error submitting the form.');
    }
  };

  return (
    <div className="submit-complaint-page">
      <h1>Contact Information</h1>
      <div className="contact-info">
        <p>
          <FaEnvelope /> <strong>Email:</strong> <span style={{ marginLeft: '10px' }}>kaust.breaking.law@gmail.com</span>
        </p>
        <p>
          <FaTelegramPlane /> <strong>WhatsUp: </strong> <span style={{ marginLeft: '10px' }}>+7 (771) 366-08-75</span>
        </p>
      </div>
      <h2>Feedback Form</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Your Name</label>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Message</label>
          <textarea rows="5" value={message} onChange={(e) => setMessage(e.target.value)} required></textarea>
        </div>
        <div className="form-group">
          <label>Attach Files (Number of files: {files.length})</label>
          <label className="btn-custom-file" htmlFor="file-upload">
            Choose Files
          </label>
          <input
            type="file"
            id="file-upload"
            multiple
            onChange={handleFileChange}
          />
          <ul>
            {files.map((file, index) => (
              <li key={index}>
                {file.name}{' '}
                <button type="button" onClick={() => handleRemoveFile(index, 'file')}>
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="form-group">
          <label>Attach Photos (Number of photos: {photos.length})</label>
          <label className="btn-custom-file" htmlFor="photo-upload">
            Choose Photos
          </label>
          <input
            type="file"
            id="photo-upload"
            multiple
            accept="image/*"
            onChange={handlePhotoChange}
          />
          <ul>
            {photos.map((photo, index) => (
              <li key={index}>
                {photo.name}{' '}
                <button type="button" onClick={() => handleRemoveFile(index, 'photo')}>
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>
        <button type="submit" className="btn-submit">Submit</button>
      </form>
    </div>
  );
};

export default SubmitComplaintPage;
